/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ volume: NonNullable<unknown> }} Workout_After_End_VolumeInputs */

const en_us2_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volume} lifted`)
};

const pt_br2_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volume} levantadas`)
};

const es_419_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levantaste ${i?.volume}`)
};

const pt_pt2_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volume} levantadas`)
};

const fr_fr2_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total soulevé : ${i?.volume}`)
};

const de_de2_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volume} bewegt`)
};

const it_it2_workout_after_end_volume = /** @type {(inputs: Workout_After_End_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totale sollevato: ${i?.volume}`)
};

/**
* | output |
* | --- |
* | "{volume} lifted" |
*
* @param {Workout_After_End_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_volume = /** @type {((inputs: Workout_After_End_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_volume(inputs)
	if (locale === "es-419") return es_419_workout_after_end_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_volume(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_volume(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_volume(inputs)
	return en_us2_workout_after_end_volume(inputs)
});
export { workout_after_end_volume as "workout-after.end_volume" }